/* Little Label cart conversion — cart drawer + /cart (rev. 2026-10-25, owner's cart spec + free AU shipping).
   Everything here is rendered from LIVE Shopify cart data (/cart.js or the cart object the theme's CartApi emits):
   - Free-shipping bar           [data-ll-ship]     (spec #1) — AU: free on every order; other countries: threshold bar
   - Little Bloom discount line  in [data-ll-cx-offer] (spec #2) — only states a discount once Shopify has applied it
   - "More little favourites" carousel in [data-ll-cx-offer] (spec #3/#4) — every available Little Bloom product,
     owner's pairing order, deliberate size choice, adding state, duplicate-submit guard, aria-live confirmation
   - Order summary               [data-ll-sum]      (spec #5) — Subtotal / Savings / Shipping / Total
     (when shipping is free the standard rate is shown struck out and counted in Savings)
   - Line-item size change       select[data-ll-line-size] (spec #4)
   - Same-day dispatch countdown [data-ll-cx-dispatch] (Mon–Fri before 4pm Australia/Sydney)
   Shipping threshold + rates are NOT defined here: they are read from data-ll-ship-cfg, rendered by
   snippets/ll-cart-totals.liquid (the single place to change them). A threshold of 1 (cent) means always free.
   Line keys are never trusted (Little Bloom automatic discounts re-key every line after any change): lines are
   resolved by variant id from a fresh /cart.js read immediately before each mutation.
   All listeners are delegated on document and bound once (guarded by window.__llCx), so drawer re-renders
   never duplicate handlers. */
(function () {
  if (window.__llCx) return;
  window.__llCx = true;

  var cfgBloom = window.llBloom || {};
  var catalog = null;
  var lastCart = null;
  var busy = false;
  var chosen = {};          // productId -> variantId the shopper picked in the carousel (survives re-renders)
  var status = null;        // { text, kind: 'ok'|'error', at }
  var addedFlash = {};      // productId -> timestamp of last successful add (button shows "Added")

  // Owner's pairing rules (spec #3). Keys/values are product "families" (see family()).
  var PAIRS = {
    willow: ['oatley', 'willow'],
    blossom: ['colette', 'blossom', 'bandana'],
    colette: ['blossom', 'bandana'],
    oatley: ['willow'],
    bandana: ['blossom', 'colette']
  };

  /* ---------- helpers ---------- */
  function fmt(cents) {
    var tc = window.themeCore;
    var shop = tc && tc.objects && tc.objects.shop;
    if (tc && tc.utils && tc.utils.formatMoney && shop && shop.money_format) {
      try { return tc.utils.formatMoney(Math.round(cents), shop.money_format); } catch (e) {}
    }
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }
  function fmtShort(cents) { var s = fmt(cents); return /\.00$/.test(s) ? s.slice(0, -3) : s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function family(title) {
    var t = String(title || '').toLowerCase();
    var keys = ['willow', 'blossom', 'colette', 'oatley', 'bandana'];
    for (var i = 0; i < keys.length; i++) if (t.indexOf(keys[i]) > -1) return keys[i];
    return t.split(' - ')[0].trim();
  }
  function shortName(title) { return String(title || '').replace(/^The\s+/i, ''); }

  function loadCatalog() {
    if (catalog) return catalog;
    var el = document.querySelector('[data-ll-cx-catalog]');
    if (!el) return null;
    try { catalog = JSON.parse(el.textContent); } catch (e) { catalog = null; }
    return catalog;
  }
  function bloomIds() {
    var ids = {};
    (loadCatalog() || []).forEach(function (p) { ids[p.id] = true; });
    (cfgBloom.ids || []).forEach(function (id) { ids[id] = true; });
    return ids;
  }

  /* ---------- shipping (spec #1/#5) ---------- */
  function shipCfg() {
    var el = document.querySelector('[data-ll-ship-cfg]');
    var c = null;
    if (el) { try { c = JSON.parse(el.getAttribute('data-ll-ship-cfg')); } catch (e) {} }
    c = c || { threshold: 1, rates: { AU: 995, NZ: 1195 }, country: 'AU', base: 'AUD' };
    if (window.Shopify && window.Shopify.country) c.country = window.Shopify.country;
    return c;
  }
  function shipping(cart) {
    var c = shipCfg();
    var base = c.rates[c.country];
    var cur = cart.currency || c.base;
    var rate = 1;
    if (cur !== c.base) {
      rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 0;
    }
    if (base == null || !rate) return { known: false, country: c.country };
    // Australia: free shipping on every order. Other countries keep the threshold from the config.
    var always = c.country === 'AU' || Number(c.threshold) <= 1;
    var threshold = always ? 1 : Math.round(c.threshold * rate);
    var cost = Math.round(base * rate);
    var total = cart.total_price;
    var free = always || total >= threshold;
    return {
      known: true, estimated: cur !== c.base, country: c.country, threshold: threshold, rate: cost, free: free, always: always,
      charge: free ? 0 : cost, left: always ? 0 : Math.max(0, threshold - total),
      pct: always ? 100 : Math.min(100, Math.floor(total * 100 / threshold))
    };
  }

  function renderShip(el, cart, sh) {
    if (!cart.item_count || !sh.known) { el.hidden = true; return; }
    el.hidden = false;
    el.classList.toggle('is-free', sh.free);
    el.classList.toggle('ll-ship--always', !!sh.always);
    var msg = el.querySelector('[data-ll-ship-msg]');
    var track = el.querySelector('[data-ll-ship-track]');
    var tick = '<svg class="ll-ship__icon" aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="14" height="14"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var html;
    if (sh.always) html = tick + 'Free Australia-wide shipping on every order';
    else if (sh.free) html = tick + 'Free ' + esc(sh.country) + ' shipping unlocked';
    else html = 'You’re <strong>' + (sh.estimated ? '≈' : '') + fmt(sh.left) + '</strong> away from free ' + esc(sh.country) + ' shipping';
    if (msg && msg.innerHTML !== html) msg.innerHTML = html;
    if (track) {
      track.hidden = !!sh.always;
      track.setAttribute('aria-valuenow', String(sh.pct));
      var fill = track.querySelector('.ll-ship__fill');
      if (fill) fill.style.width = sh.pct + '%';
    }
  }

  function renderSummary(el, cart, sh) {
    var saved = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
    if (sh.known && sh.free) saved += sh.rate;   // free shipping counts as a saving (standard rate struck out below)
    var set = function (sel, html) { var n = el.querySelector(sel); if (n && n.innerHTML !== html) n.innerHTML = html; };
    set('[data-ll-sum-subtotal]', fmt(cart.original_total_price || 0));
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false && d.code; }).map(function (d) { return d.code; });
    var saveRow = el.querySelector('.ll-sum__row--save');
    if (saveRow) saveRow.classList.toggle('is-zero', saved <= 0);
    set('[data-ll-sum-savings-label]', 'Savings' + (codes.length ? ' <span class="ll-sum__code">(' + esc(codes.join(', ')) + ')</span>' : ''));
    set('[data-ll-sum-savings]', saved > 0 ? '−' + fmt(saved) : fmt(0));
    if (sh.known) {
      set('[data-ll-sum-ship-label]', 'Shipping (' + esc(sh.country) + (sh.estimated ? ', est.' : '') + ')');
      set('[data-ll-sum-ship]', sh.free
        ? '<s class="ll-sum__was">' + fmt(sh.rate) + '</s> <span class="ll-sum__free">FREE</span>'
        : fmt(sh.rate));
      set('[data-ll-sum-total-label]', sh.estimated ? 'Estimated total' : 'Total');
      set('[data-ll-sum-total]', fmt(cart.total_price + sh.charge));
    } else {
      set('[data-ll-sum-ship-label]', 'Shipping');
      set('[data-ll-sum-ship]', '<span class="ll-sum__note">Calculated at checkout</span>');
      set('[data-ll-sum-total-label]', 'Total');
      set('[data-ll-sum-total]', fmt(cart.total_price));
    }
    el.setAttribute('data-total', String(cart.total_price));
    el.setAttribute('data-count', String(cart.item_count));
  }

  /* ---------- Little Bloom state (spec #2) ---------- */
  function bloomState(cart) {
    var ids = bloomIds();
    var qty = 0, appliedPct = 0, applied = false, lines = [], lbDisc = 0;
    (cart.items || []).forEach(function (it) {
      if (!ids[it.product_id]) return;
      qty += it.quantity;
      lines.push(it.original_line_price != null ? it.original_line_price : it.line_price);
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (/little bloom/i.test(app.title || '') && a.amount > 0) {
          applied = true;
          lbDisc += a.amount;
          var m = /(\d+)\s*%/.exec(app.title || '');
          var p = app.value_type === 'percentage' && app.value ? Math.round(Number(app.value)) : (m ? Number(m[1]) : 0);
          if (p > appliedPct) appliedPct = p;
        }
      });
    });
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
    return { qty: qty, applied: applied, pct: appliedPct, codes: codes, lines: lines, lbDisc: lbDisc };
  }

  function tiersList() { return cfgBloom.tiers || [[2, 10], [3, 15], [4, 25]]; }
  function tierPct(q) { var p = 0; tiersList().forEach(function (t) { if (q >= t[0]) p = t[1]; }); return p; }

  // Owner copy (two short lines). Only states a saving once Shopify has applied it.
  function two(l1, l2, tick) {
    return '<span class="ll-cx-msg__l1">' + (tick ? '<span class="ll-cx-msg__tick" aria-hidden="true">✓</span>' : '') + l1 + '</span>' +
      (l2 ? '<span class="ll-cx-msg__l2">' + l2 + '</span>' : '');
  }
  function messageHtml(b) {
    var tiers = tiersList();
    var first = tiers[0] || [2, 10];
    if (b.applied && b.pct) {
      var next = null;
      tiers.forEach(function (t) { if (!next && t[1] > b.pct && t[0] === b.qty + 1) next = t; });
      return { cls: 'is-active', html: two('You’re saving ' + b.pct + '%', next ? 'Add 1 more Little Bloom piece to unlock ' + next[1] + '% off.' : 'Our best Little Bloom price.', true) };
    }
    // A discount code is applied instead (Little Bloom mix & match doesn't combine with codes): say so honestly.
    if (b.codes.length) return { cls: 'is-note', html: two('Little Bloom savings can’t be combined', 'with code ' + esc(b.codes.join(', ')) + '.') };
    if (b.qty >= first[0]) return null;
    if (b.qty === first[0] - 1 && b.qty > 0) return { cls: '', html: two('Add another Little Bloom piece', 'Save ' + first[1] + '% on both.') };
    return { cls: '', html: two('Mix any ' + first[0] + ' Little Bloom pieces', 'Save ' + first[1] + '% on both.') };
  }

  /* ---------- "Price if added" on each card (owner refinement #3) ----------
     From the CURRENT cart: Little Bloom piece count (quantities included) + 1 → tier → this piece's price.
     Shopify allocates the percentage per line and rounds to the cent, so: save = round(price × pct / 100).
     bag = ONLY the extra discount the tier change gives the pieces already in the cart (per-line rounding again);
     the recommended piece's own discount is not included. Shown as "Plus $X off your current cart." when > 0.
     No deal is shown when a discount code is applied (codes don't combine with mix & match). */
  function dealFor(p, b) {
    if (!b || b.codes.length) return null;
    var pct = tierPct(b.qty + 1);
    if (!pct) return null;
    var save = Math.round(p.price * pct / 100);
    var bag = 0;
    if (pct > (b.applied ? b.pct : 0)) {
      b.lines.forEach(function (orig) { bag += Math.round(orig * pct / 100); });
      bag = Math.max(0, bag - b.lbDisc);
    }
    return { pct: pct, price: p.price - save, save: save, bag: bag };
  }

  /* ---------- Carousel order (spec #3) ---------- */
  function ordered(cart) {
    var cat = loadCatalog() || [];
    var inCart = {};
    var fams = [];
    (cart.items || []).forEach(function (it) {
      inCart[it.product_id] = true;
      var f = family(it.product_title);
      if (PAIRS[f] && fams.indexOf(f) < 0) fams.push(f);   // cart.items is newest-first
    });
    return cat
      .map(function (p, i) {
        var avail = p.variants.some(function (v) { return v.available; });
        if (!avail) return null;
        var score;
        if (inCart[p.id]) score = 1000 + i;
        else {
          score = 500 + i;
          var f = family(p.title);
          fams.forEach(function (cf, j) {
            var r = PAIRS[cf].indexOf(f);
            if (r > -1) score = Math.min(score, r * 10 + j + i / 100);
          });
        }
        return { p: p, score: score, inCart: !!inCart[p.id] };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.score - b.score; });
  }

  function cardHtml(o, b) {
    var p = o.p;
    var d = dealFor(p, b);
    var single = p.variants.length === 1;
    var pick = single ? p.variants[0].id : chosen[p.id];
    if (pick && !p.variants.some(function (v) { return v.id === pick && v.available; })) { pick = null; delete chosen[p.id]; }
    var name = shortName(p.title);
    var sizes = single
      ? '<p class="ll-cx-card__onesize">' + esc(p.variants[0].title === 'Default Title' ? 'One size' : p.variants[0].title) + '</p>'
      : '<div class="ll-cx-card__sizes" role="group" aria-label="Size for ' + esc(name) + '">' + p.variants.map(function (v) {
          var on = pick === v.id;
          return '<button type="button" class="ll-cx-chip" data-ll-cx-size="' + v.id + '" aria-pressed="' + (on ? 'true' : 'false') + '"' +
            (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' sold out"') + '>' + esc(v.title) + '</button>';
        }).join('') + '</div>';
    var flash = addedFlash[p.id] && Date.now() - addedFlash[p.id] < 2500;
    var ready = !!pick;
    var label = flash ? 'Added ✓' : (ready ? 'Add' : 'Choose a size');
    var tag = o.inCart ? ' <span class="ll-cx-card__tag">In cart</span>' : '';
    var pricing = d
      ? '<p class="ll-cx-card__price" data-ll-cx-price="' + d.price + '"><s class="ll-cx-card__was"><span class="visually-hidden">Was </span>' + fmtShort(p.price) + '</s> ' +
          '<span class="ll-cx-card__now">' + fmt(d.price) + '</span> <span class="ll-cx-card__when">when added</span>' + tag + '</p>' +
        (d.bag > 0 ? '<p class="ll-cx-card__bag">Plus ' + fmt(d.bag) + ' off your current cart.</p>' : '')
      : '<p class="ll-cx-card__price" data-ll-cx-price="' + p.price + '">' + fmtShort(p.price) + tag + '</p>';
    return '<div class="ll-cx-card' + (o.inCart ? ' is-in-cart' : '') + '" data-ll-cx-card data-pid="' + p.id + '" data-title="' + esc(name) + '">' +
      '<div class="ll-cx-card__top">' +
        '<a class="ll-cx-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="80">' : '') + '</a>' +
        '<div class="ll-cx-card__info"><a class="ll-cx-card__name" href="' + esc(p.url) + '">' + esc(name) + '</a>' + pricing + '</div>' +
      '</div>' +
      '<div class="ll-cx-card__bottom">' + sizes +
        '<button type="button" class="ll-cx-card__add' + (flash ? ' is-added' : '') + '" data-ll-cx-add aria-disabled="' + (ready ? 'false' : 'true') + '">' + label + '</button>' +
      '</div>' +
      '</div>';
  }

  function renderOffer(host, cart) {
    host.setAttribute('data-ll-cx-done', '');
    if (!cart || !cart.item_count) { host.hidden = true; host.innerHTML = ''; return; }
    var b = bloomState(cart);
    var m = messageHtml(b);
    var list = ordered(cart);
    if (!m && !list.length) { host.hidden = true; host.innerHTML = ''; return; }

    if (!host.querySelector('[data-ll-cx-row]')) {
      host.innerHTML =
        '<p class="ll-cx-msg" data-ll-cx-msg></p>' +
        '<div class="ll-cx-look"' + (list.length ? '' : ' hidden') + '>' +
          '<div class="ll-cx-look__head"><p class="ll-cx-look__title" id="ll-cx-look-title-' + (host.dataset.context || 'drawer') + '">More little favourites</p>' +
            '<div class="ll-cx-look__nav">' +
              '<button type="button" class="ll-cx-nav" data-ll-cx-nav="-1" aria-label="Previous recommendation" disabled><svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="14" height="14"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
              '<button type="button" class="ll-cx-nav" data-ll-cx-nav="1" aria-label="Next recommendation"><svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="14" height="14"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            '</div></div>' +
          '<p class="ll-cx-look__cue" aria-hidden="true">Swipe to explore →</p>' +
          '<div class="ll-cx-look__row" data-ll-cx-row role="region" aria-roledescription="carousel" aria-labelledby="ll-cx-look-title-' + (host.dataset.context || 'drawer') + '" tabindex="0"></div>' +
          '<p class="ll-cx-look__status" role="status" aria-live="polite" data-ll-cx-status></p>' +
          '<p class="ll-cx-look__error" role="alert" data-ll-cx-error hidden></p>' +
        '</div>';
    }
    var msgEl = host.querySelector('[data-ll-cx-msg]');
    if (m) { msgEl.className = 'll-cx-msg ' + m.cls; if (msgEl.innerHTML !== m.html) msgEl.innerHTML = m.html; msgEl.hidden = false; }
    else { msgEl.hidden = true; msgEl.innerHTML = ''; }

    var look = host.querySelector('.ll-cx-look');
    look.hidden = !list.length;
    var row = host.querySelector('[data-ll-cx-row]');
    var html = list.map(function (o) { return cardHtml(o, b); }).join('');
    if (row.__llHtml !== html) {
      var sl = row.scrollLeft;
      row.innerHTML = html;
      row.__llHtml = html;
      row.scrollLeft = sl;
    }
    if (ro && !row.__llRo) { row.__llRo = true; ro.observe(row); }   // drawer opens → row gets a size → arrows/cue update
    updateNav(row);
    renderStatus(host);
    host.hidden = false;
  }

  /* ---------- carousel arrows + swipe guard (owner refinement) ---------- */
  function updateNav(row) {
    var look = row && row.closest('.ll-cx-look');
    if (!look) return;
    var max = row.scrollWidth - row.clientWidth;
    look.querySelectorAll('[data-ll-cx-nav]').forEach(function (btn) {
      var dir = Number(btn.getAttribute('data-ll-cx-nav'));
      btn.disabled = dir < 0 ? row.scrollLeft <= 2 : row.scrollLeft >= max - 2;
    });
    look.classList.toggle('is-scrollable', max > 2);
  }
  // Scroll events don't bubble: listen in the capture phase once for every carousel row.
  document.addEventListener('scroll', function (e) {
    var row = e.target && e.target.closest && e.target.closest('[data-ll-cx-row]');
    if (row === e.target) { if (drag && drag.row === row) drag.scrolled = true; updateNav(row); }
  }, true);
  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) { entries.forEach(function (en) { updateNav(en.target); }); }) : null;
  window.addEventListener('resize', function () { document.querySelectorAll('[data-ll-cx-row]').forEach(updateNav); });
  // A horizontal swipe must never count as a size tap or an Add: remember where the pointer went down and whether
  // the row scrolled before the click arrives.
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    var row = e.target.closest && e.target.closest('[data-ll-cx-row]');
    drag = row ? { row: row, x: e.clientX, y: e.clientY, sl: row.scrollLeft, moved: false, scrolled: false } : null;
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (drag && !drag.moved && (Math.abs(e.clientX - drag.x) > 8 || Math.abs(e.clientY - drag.y) > 8)) drag.moved = true;
  }, true);
  function wasSwipe(target) {
    if (!drag || !drag.row.contains(target)) return false;
    return drag.moved || drag.scrolled || Math.abs(drag.row.scrollLeft - drag.sl) > 2;
  }

  function renderStatus(host) {
    var st = host.querySelector('[data-ll-cx-status]');
    var er = host.querySelector('[data-ll-cx-error]');
    if (!st || !er) return;
    var fresh = status && Date.now() - status.at < 6000;
    var ok = fresh && status.kind === 'ok' ? status.text : '';
    var bad = fresh && status.kind === 'error' ? status.text : '';
    if (st.textContent !== ok) st.textContent = ok;
    if (er.textContent !== bad) er.textContent = bad;
    er.hidden = !bad;
  }

  function setStatus(text, kind) {
    status = { text: text, kind: kind, at: Date.now() };
    document.querySelectorAll('[data-ll-cx-offer]').forEach(renderStatus);
    clearTimeout(setStatus.t);
    setStatus.t = setTimeout(function () { document.querySelectorAll('[data-ll-cx-offer]').forEach(renderStatus); }, 6100);
  }

  /* ---------- render everything from one cart ---------- */
  function renderAll(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    var sh = shipping(cart);
    document.querySelectorAll('[data-ll-ship]').forEach(function (el) { renderShip(el, cart, sh); el.setAttribute('data-ll-done', ''); });
    document.querySelectorAll('[data-ll-sum]').forEach(function (el) { renderSummary(el, cart, sh); el.setAttribute('data-ll-done', ''); });
    document.querySelectorAll('[data-ll-cx-offer]').forEach(function (h) { renderOffer(h, cart); });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  // Keep the drawer where the shopper left it while the theme swaps its markup.
  function scroller() { return document.querySelector('#CartDrawer .js-cart-container'); }
  function refreshTheme() {
    var sc = scroller();
    var top = sc ? sc.scrollTop : 0;
    var restore = function () { var s = scroller(); if (s && Math.abs(s.scrollTop - top) > 2) s.scrollTop = top; };
    var tc = window.themeCore;
    var p = tc && tc.CartApi && tc.CartApi.makeRequest
      ? Promise.resolve(tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART, { noOpen: true })).catch(function () {})
      : Promise.resolve();
    return p.then(function () {
      if (tc && tc.EventBus) tc.EventBus.emit('cart:refresh');
      return getCart().then(function (c) { renderAll(c); restore(); setTimeout(restore, 400); setTimeout(restore, 900); return c; });
    });
  }

  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || (j && j.status && Number(j.status) >= 400)) throw new Error((j && (j.description || j.message)) || 'Request failed');
          return j;
        });
      });
  }

  /* ---------- clicks: size pills + Add (spec #4) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = t.closest && t.closest('[data-ll-cx-nav]');
    if (nav) {
      var navRow = nav.closest('.ll-cx-look').querySelector('[data-ll-cx-row]');
      var firstCard = navRow.querySelector('[data-ll-cx-card]');
      var step = firstCard ? firstCard.getBoundingClientRect().width + 8 : navRow.clientWidth * 0.85;
      navRow.scrollBy({ left: Number(nav.getAttribute('data-ll-cx-nav')) * step, behavior: 'smooth' });
      return;
    }
    if (t.closest && (t.closest('[data-ll-cx-size]') || t.closest('[data-ll-cx-add]')) && wasSwipe(t)) {
      e.preventDefault(); e.stopPropagation(); drag = null; return;
    }
    var chip = t.closest && t.closest('[data-ll-cx-size]');
    if (chip) {
      if (chip.disabled) return;
      var card = chip.closest('[data-ll-cx-card]');
      var pid = Number(card.dataset.pid);
      chosen[pid] = Number(chip.dataset.llCxSize);
      card.querySelectorAll('[data-ll-cx-size]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var b = card.querySelector('[data-ll-cx-add]');
      b.setAttribute('aria-disabled', 'false'); b.textContent = 'Add'; b.classList.remove('is-added');
      card.classList.remove('needs-size');
      var row0 = card.closest('[data-ll-cx-row]'); if (row0) row0.__llHtml = null;
      return;
    }
    var add = t.closest && t.closest('[data-ll-cx-add]');
    if (!add) return;
    e.preventDefault();
    var card2 = add.closest('[data-ll-cx-card]');
    var pid2 = Number(card2.dataset.pid);
    var p = (loadCatalog() || []).filter(function (x) { return x.id === pid2; })[0];
    if (!p) return;
    var vid = p.variants.length === 1 ? p.variants[0].id : chosen[pid2];
    var name = card2.dataset.title || 'This piece';
    if (!vid) {
      card2.classList.add('needs-size');
      setStatus('Choose a size for ' + name + ' first.', 'ok');
      var first = card2.querySelector('[data-ll-cx-size]:not([disabled])');
      if (first) first.focus();
      return;
    }
    if (busy) return;
    busy = true;
    add.setAttribute('aria-disabled', 'true'); add.classList.add('is-loading'); add.textContent = 'Adding…';
    var v = p.variants.filter(function (x) { return x.id === vid; })[0];
    var sizeTxt = p.variants.length > 1 && v ? ' (' + v.title + ')' : '';
    postJSON('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
      .then(function () {
        addedFlash[pid2] = Date.now();
        delete chosen[pid2];
        setStatus('✓ ' + name + sizeTxt + ' added to your cart.', 'ok');
        busy = false;
        return refreshTheme();
      })
      .catch(function (err) {
        busy = false;
        add.classList.remove('is-loading'); add.setAttribute('aria-disabled', 'false'); add.textContent = 'Add';
        setStatus('Sorry, ' + name + sizeTxt + ' couldn’t be added' + (err && err.message && err.message !== 'Request failed' ? ': ' + err.message : '. Please try again.') + ' Your cart hasn’t changed.', 'error');
        return getCart().then(renderAll).catch(function () {});
      })
      .then(function () { setTimeout(function () { if (lastCart) { var r = document.querySelectorAll('[data-ll-cx-row]'); r.forEach(function (x) { x.__llHtml = null; }); renderAll(lastCart); } }, 2600); });
  });

  /* ---------- line-item size change (spec #4) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-ll-line-size]');
    if (!sel) return;
    var oldId = Number(sel.dataset.variantId);
    var newId = Number(sel.value);
    var title = sel.dataset.title || 'this item';
    var row = sel.closest('[data-cart-item]');
    var errEl = row && row.querySelector('.js-cart-item-error-message');
    if (newId === oldId) return;
    if (busy) { sel.value = String(oldId); return; }
    busy = true;
    sel.disabled = true;
    if (row) row.classList.add('ll-is-updating');
    if (errEl) errEl.textContent = '';
    var newLabel = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
    var line = null;
    var added = false;
    getCart()
      .then(function (cart) {
        var idx = Number(sel.dataset.line) || 0;
        var same = cart.items.filter(function (i) { return i.variant_id === oldId; });
        line = (idx && cart.items[idx - 1] && cart.items[idx - 1].variant_id === oldId) ? cart.items[idx - 1] : same[0];
        if (!line) throw new Error('This item has already changed — refreshing your cart.');
        var props = {};
        Object.keys(line.properties || {}).forEach(function (k) { if (line.properties[k] != null && line.properties[k] !== '') props[k] = line.properties[k]; });
        var item = { id: newId, quantity: line.quantity };
        if (Object.keys(props).length) item.properties = props;
        return postJSON('/cart/add.js', { items: [item] });   // add first, so a failure never loses the item
      })
      .then(function () { added = true; return getCart(); })
      .then(function (cart) {
        // Re-resolve the old line after the add (keys change); remove it by its current position.
        var pos = -1;
        cart.items.forEach(function (i, n) { if (pos < 0 && i.variant_id === oldId && JSON.stringify(i.properties || {}) === JSON.stringify(line.properties || {})) pos = n; });
        if (pos < 0) cart.items.forEach(function (i, n) { if (pos < 0 && i.variant_id === oldId) pos = n; });
        if (pos < 0) return cart;
        return postJSON('/cart/change.js', { line: pos + 1, quantity: 0 });
      })
      .then(function () {
        busy = false;
        setStatus('Size updated to ' + newLabel + ' for ' + title + '.', 'ok');
        announce('Size updated to ' + newLabel + ' for ' + title + '.');
        return refreshTheme();
      })
      .catch(function (err) {
        busy = false;
        sel.value = String(oldId);
        sel.disabled = false;
        if (row) row.classList.remove('ll-is-updating');
        var msg = added
          ? 'The new size was added but the old one couldn’t be removed — please remove it with the bin icon.'
          : 'Couldn’t change the size' + (err && err.message && err.message !== 'Request failed' ? ': ' + err.message : '. Please try again.') + ' Your cart hasn’t changed.';
        if (errEl) errEl.textContent = msg;
        announce(msg);
        if (!added) return getCart().then(renderAll).catch(function () {});   // nothing changed: keep the row + its error
        setStatus(msg, 'error');
        return refreshTheme();
      });
  });

  // Polite screen-reader announcements for changes outside the carousel (e.g. line size changes).
  function announce(text) {
    var r = document.getElementById('ll-cx-live');
    if (!r) {
      r = document.createElement('p');
      r.id = 'll-cx-live'; r.className = 'visually-hidden'; r.setAttribute('aria-live', 'polite'); r.setAttribute('role', 'status');
      document.body.appendChild(r);
    }
    r.textContent = '';
    setTimeout(function () { r.textContent = text; }, 50);
  }

  /* ---------- Same-day dispatch countdown (Australia/Sydney) ---------- */
  var sydFmt = null;
  try { sydFmt = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hourCycle: 'h23', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) {}
  function sydneyNow() {
    var now = typeof window.__llCxNow === 'function' ? window.__llCxNow() : new Date();
    if (!sydFmt) return null;
    var p = {};
    sydFmt.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { wd: p.weekday, h: Number(p.hour) % 24, m: Number(p.minute), s: Number(p.second) };
  }
  function tickDispatch() {
    var els = document.querySelectorAll('[data-ll-cx-dispatch]');
    if (!els.length) return;
    var t = sydneyNow();
    var show = false, label = '';
    if (t && !/^(Sat|Sun)/.test(t.wd)) {
      var left = 16 * 3600 - (t.h * 3600 + t.m * 60 + t.s);
      if (left > 0) {
        show = true;
        var mins = Math.ceil(left / 60);
        var h = Math.floor(mins / 60), m = mins % 60;
        label = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
      }
    }
    els.forEach(function (el) {
      if (el.hidden !== !show) el.hidden = !show;
      var tm = el.querySelector('[data-ll-cx-dispatch-time]');
      if (show && tm && tm.textContent !== label) tm.textContent = label;
    });
  }
  window.llCxTickDispatch = tickDispatch;

  /* ---------- boot (listeners bound exactly once) ---------- */
  var booted = false;
  function boot() {
    tickDispatch();
    var tc = window.themeCore;
    if (!tc || !tc.EventBus) { setTimeout(boot, 300); return; }
    if (booted) return;
    booted = true;
    tc.EventBus.listen('cart:updated', function (cart) { if (cart && cart.items) renderAll(cart); });
    if (tc.cartObject && tc.cartObject.items) renderAll(tc.cartObject);
    getCart().then(renderAll).catch(function () {});
  }
  setInterval(tickDispatch, 5000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tickDispatch(); });

  // The theme swaps drawer markup after cart changes (server-rendered from the same cart). Re-apply our rendering to
  // any fresh node; if its server cart differs from the last cart we saw, fetch the live cart first.
  var pending = false;
  var mo = new MutationObserver(function () {
    tickDispatch();
    if (!lastCart) return;
    var fresh = document.querySelectorAll('[data-ll-ship]:not([data-ll-done]), [data-ll-sum]:not([data-ll-done]), [data-ll-cx-offer]:not([data-ll-cx-done])');
    if (!fresh.length) return;
    var stale = false;
    fresh.forEach(function (el) {
      if (el.hasAttribute('data-total') && (Number(el.getAttribute('data-total')) !== lastCart.total_price || Number(el.getAttribute('data-count')) !== lastCart.item_count)) stale = true;
    });
    if (!stale) { renderAll(lastCart); return; }
    // Server markup is newer than our last cart: keep it on screen and re-render from a fresh /cart.js read.
    if (!pending) {
      pending = true;
      getCart().then(function (c) { pending = false; renderAll(c); }).catch(function () { pending = false; renderAll(lastCart); });
    }
  });
  function observe() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { observe(); boot(); }); else { observe(); boot(); }
  document.addEventListener('theme:all:loaded', boot);
  document.addEventListener('ll:cart-changed', function () { if (!busy) getCart().then(renderAll).catch(function () {}); });
})();